module.exports = __webpack_public_path__ + "img/b012_2.2109920c.jpg";